import { render, staticRenderFns } from "./vImpressao.vue?vue&type=template&id=639e56c6&scoped=true"
import script from "./vImpressao.vue?vue&type=script&lang=js"
export * from "./vImpressao.vue?vue&type=script&lang=js"
import style0 from "./vImpressao.vue?vue&type=style&index=0&id=639e56c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639e56c6",
  null
  
)

export default component.exports